import { cn } from "@/lib/utils";

/**
 * Pulsating live operations card — used in the realtime ops grid.
 * Has a subtle animated dot when the count > 0 to feel "alive".
 */
export default function LiveOpCard({
  label,
  value = 0,
  icon: Icon,
  accent = "primary",
  hint,
  active = null, // explicit override; null → derive from value
  testid,
}) {
  const isActive = active === null ? Number(value) > 0 : !!active;
  const colorMap = {
    emerald: { dot: "bg-emerald-500", ring: "bg-emerald-500/40", bg: "bg-emerald-500/10", icon: "text-emerald-600" },
    amber:   { dot: "bg-amber-500",   ring: "bg-amber-500/40",   bg: "bg-amber-500/10",   icon: "text-amber-600" },
    rose:    { dot: "bg-rose-500",    ring: "bg-rose-500/40",    bg: "bg-rose-500/10",    icon: "text-rose-600" },
    violet:  { dot: "bg-violet-500",  ring: "bg-violet-500/40",  bg: "bg-violet-500/10",  icon: "text-violet-600" },
    sky:     { dot: "bg-sky-500",     ring: "bg-sky-500/40",     bg: "bg-sky-500/10",     icon: "text-sky-600" },
    primary: { dot: "bg-primary",     ring: "bg-primary/40",     bg: "bg-primary/10",     icon: "text-primary" },
  };
  const c = colorMap[accent] || colorMap.primary;
  return (
    <div
      className="rounded-xl border border-border bg-white p-4 flex items-center gap-3"
      data-testid={testid}
    >
      <div className={cn("h-9 w-9 rounded-md flex items-center justify-center shrink-0", c.bg)}>
        {Icon && <Icon className={cn("h-4 w-4", c.icon)} />}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground truncate">
          {label}
        </div>
        <div className="mt-0.5 flex items-baseline gap-2">
          <div className="font-display text-xl font-bold tabular-nums">{Number(value).toLocaleString("ro-RO")}</div>
          {hint && <span className="text-[11px] text-muted-foreground">{hint}</span>}
        </div>
      </div>
      {isActive && (
        <span className="relative inline-flex h-2 w-2 shrink-0" title="Live">
          <span className={cn("absolute inset-0 inline-flex h-full w-full rounded-full opacity-75 animate-ping", c.ring)} />
          <span className={cn("relative inline-flex h-2 w-2 rounded-full", c.dot)} />
        </span>
      )}
    </div>
  );
}
